import { CumulativeBooster } from "./cumulative_booster.js";
import { CumulativeBoosterID } from "./cumulative_booster_id.js";

/* Base for effects which stay active for a fixed number of seconds. */
export abstract class TimedCumulativeBooster<TContext> extends CumulativeBooster<TContext>
{
  public readonly duration: number;

  private elapsed = 0;
  private timer_running: boolean;
  private readonly start_immediately: boolean;

  protected constructor( id: CumulativeBoosterID, duration: number, start_immediately = true )
  {
    super( id );

    if ( !Number.isFinite( duration ) || duration <= 0 )
      throw new Error( "Booster duration must be a finite positive number" );

    this.duration = duration;
    this.start_immediately = start_immediately;
    this.timer_running = start_immediately;
  }

  public get elapsedTime(): number
  {
    return this.elapsed;
  }

  public get remainingTime(): number
  {
    return Math.max( 0, this.duration - this.elapsed );
  }

  public startTimer(): boolean
  {
    if ( !this.isActive || this.timer_running )
      return false;

    this.timer_running = true;
    return true;
  }

  protected override onUpdate( context: TContext, dt: number ): void
  {
    if ( !this.timer_running )
      return;

    this.elapsed = Math.min( this.duration, this.elapsed + dt );
    this.onTimedUpdate( context, dt, this.remainingTime );

    if ( this.elapsed >= this.duration )
      this.complete();
  }

  protected onTimedUpdate( _context: TContext, _dt: number, _remaining_time: number ): void
  {
  }

  protected override onReset(): void
  {
    this.elapsed = 0;
    this.timer_running = this.start_immediately;
  }
}
